/* eslint-disable react/prop-types */
import { Box } from "@chakra-ui/react";
import { TableauViz } from "@tableau/embedding-api-react";
import { useRef } from "react";

export default function TableauEmbed({ embedData }) {
  const vizRef = useRef(null);

  return (
    <Box
      width="100%"
      height="100%"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Box width="100%" height="100%">
        <TableauViz
          ref={vizRef}
          id={`tableau-viz-${embedData.id}`}
          src={embedData.embedd}
          hideToolbar={false}
          hideTabs={true}
          width="100%"
          height="90vh"
        />
      </Box>
    </Box>
  );
}
